import { connect } from 'react-redux'
import SetTax from './view'

export default connect(null, {})(SetTax)
